<div class="input-group">
  <select class="form-control"
    [formControl]="selectFormControl"
    [class.form-select]="props.customSelect"
    [class.is-invalid]="showError"
    [formlyAttributes]="field"
    (ngModelChange)="onSelectionChange($event)">
    @if (props.placeholder) {
      <option [ngValue]="null">{{ props.placeholder }}</option>
    }
    @for (item of props.options | formlySelectOptions:field | async; track item.label) {
      @if (item.group) {
        <optgroup label="{{item.label}}">
          @for (child of item.group; track child.label) {
            <option [ngValue]="child.value" [disabled]="child.disabled">
              {{ child.label }}
            </option>
          }
        </optgroup>
      }
      @if (!item.group) {
        <option [ngValue]="item.value" [disabled]="item.disabled">{{ item.label }}</option>
      }
    }
  </select>
  <div class="input-group-append">
    <button [type]="props.type"
      [ngClass]="'btn ' + props.btnClass"
      (click)="onClick($event)"
      [disabled]="props.disabled">
      @if (props.icon) {
        <fa-icon [icon]="['fas', props.icon]"
          transform="shrink-3"
          [fixedWidth]="true"
          >
        </fa-icon>
      }
      @if (props.text) {
        <span>{{ props.text }}</span>
      }
    </button>
  </div>
</div>
